import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: api.health,
    refetchInterval: 10_000,
  });
}

export function useConfig() {
  return useQuery({
    queryKey: ['config'],
    queryFn: api.config,
    staleTime: 60_000,
  });
}
